import './style.scss'
import { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import utility from 'src/utils/utility'
import { CustomContainer, ScreenContainer } from 'src/style';
import { ReportFilter, ServerSideTable } from 'src/component';
import helpers from 'src/utils/helpers';
import { accountUpgradeRequestColumn, accountUpgradeRequestData } from 'src/utils/tableLayout';
import {useTranslation} from 'react-i18next';

const AccountUpgradeRequests = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const {info: {selectedAccountUpgradeRequest}, setInfoProperty} = useContext(AppInfoContext)
    const [requestsData, setRequestsData] = useState<any>(null)
    const [requests, setRequests] = useState<any>(null)
    const [showFilter, setShowFilter] = useState<boolean>(false)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const { t } = useTranslation()

    const filterDataRef = useRef({})
    
    useEffect(() => {
        filterDataRef.current = {}
        handleFetchRequests()
    }, [])

    async function handleFetchRequests (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = await API.getAccountUpgradeRequests(pageNumber, pageSize, {...filterDataRef.current, returnMax: isDownload})
        if (response) {
            if (isDownload) {
                return downloadReport(response, t('customer.upgrade.downloadFileName'))
            }
            setRequestsData(response)
            setRequests(helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize}))
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchRequests()
        setResetPagination(!resetPagination)
    }

    async function handleViewDetails (data: any) {
        await setInfoProperty('selectedAccountUpgradeRequest', data)
        navigate(`/dashboard/account-upgrade-details`)
    }

    return (
        <>
            <ScreenContainer>
                <CustomContainer topMargin='3'>
                    <ServerSideTable
                        tableData={requests}
                        tableColumns={accountUpgradeRequestColumn(handleViewDetails,t )} 
                        dataFetchMethod={handleFetchRequests}
                        totalRows={requestsData?.total}
                        tableTitle={t('customer.upgrade.tableTitle')}
                        customStyle
                        shouldResetPagination={resetPagination}
                        //canSearch
                        canFilter={() => setShowFilter(true)}
                        canClear={handleClear}
                        downloadAction={() => handleFetchRequests(1, 10, true)}
                    />
                </CustomContainer>
            </ScreenContainer>
            { showFilter &&
                <ReportFilter
                    type='account-upgarde'
                    onApplyFilter={handleFetchRequests}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setShowFilter(false)} 
                />
            }
        </>
    )
}

export default utility.routeData('account-upgrade-requests', 'Account Upgrade Requests', <AccountUpgradeRequests/>)